/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { Container, ContainerProps, Image } from "@carrotfertility/carotene"
import React from "react"
import { useIntl } from "react-intl"

export const UnderwaterSeaweed = (props: ContainerProps): JSX.Element => {
  const intl = useIntl()
  return (
    <Container {...props}>
      <Image
        src={require(`../resources/images/underwater-seaweed.png`)}
        srcSet={require(`../resources/images/underwater-seaweed-2x.png`)}
        altText={intl.formatMessage({
          defaultMessage: "Illustration of underwater seaweed"
        })}
        width={"128px"}
        height={"72px"}
        sx={{
          transform: "scaleX(-1)"
        }}
      />
    </Container>
  )
}
export const UnderwaterPlants = (props: ContainerProps): JSX.Element => {
  const intl = useIntl()
  return (
    <Container {...props}>
      <Image
        src={require(`../resources/images/underwater-plants.png`)}
        srcSet={require(`../resources/images/underwater-plants-2x.png`)}
        altText={intl.formatMessage({
          defaultMessage: "Illustration of underwater plants"
        })}
        width={"156px"}
        height={"96px"}
        sx={{
          transform: "scaleX(-1)"
        }}
      />
    </Container>
  )
}
export const UnderwaterPlantsRight = (props: ContainerProps): JSX.Element => {
  const intl = useIntl()
  return (
    <Container {...props}>
      <Image
        src={require(`../resources/images/underwater-plants-right.png`)}
        srcSet={require(`../resources/images/underwater-plants-right-2x.png`)}
        altText={intl.formatMessage({
          defaultMessage: "Illustration of underwater plants"
        })}
        width={"188px"}
        height={"96px"}
        sx={{
          transform: "scaleX(-1)"
        }}
      />
    </Container>
  )
}

export const Person = (props: ContainerProps): JSX.Element => {
  const intl = useIntl()
  return (
    <Container {...props}>
      <Image
        src={require(`../resources/images/person_right.png`)}
        altText={intl.formatMessage({
          defaultMessage: "Illustration of a person in a thinking pose. They are standing and looking to the left."
        })}
        width={"225px"}
        height={"480px"}
      />
    </Container>
  )
}
